__turbopack_context__.v({
  "Item": "Accordion-module-scss-module__5NM6mW__Item",
  "ItemTimeline": "Accordion-module-scss-module__5NM6mW__ItemTimeline",
  "List": "Accordion-module-scss-module__5NM6mW__List",
});
